module.exports = __webpack_public_path__ + "static/media/img-manner-drink.d1258921.svg";